module.exports = __webpack_public_path__ + "img/patchnotes.b23d5e85.svg";